export default __webpack_public_path__ + "static/media/offerBannerOne.ca227eca.png";